import type { SubscriptionAddon as PopsSubscriptionAddon } from '@/types/pops'

export class SubscriptionAddon {
  id: number
  title: string
  category: string
  sku: string
  quantity: number
  pricePerUnit: number
  addonProductId: number
  maxAllowed: number
  maxAllowedPerCategory: number
  productHandle: string

  constructor(rawSubscriptionAddon: PopsSubscriptionAddon) {
    this.id = rawSubscriptionAddon.id
    this.title = rawSubscriptionAddon.title
    this.category = rawSubscriptionAddon.category
    this.sku = rawSubscriptionAddon.sku
    this.quantity = rawSubscriptionAddon.quantity
    this.pricePerUnit = parseFloat(rawSubscriptionAddon.price_per_unit)
    this.addonProductId = rawSubscriptionAddon.addon_product_id
    this.maxAllowed = rawSubscriptionAddon.max_allowed
    this.maxAllowedPerCategory = rawSubscriptionAddon.max_allowed_per_category
    this.productHandle = rawSubscriptionAddon.product_handle
  }
}
